module.exports = __webpack_public_path__ + "img/Defi_on.45ae3f1f.png";